import React, { useState } from "react";

import { Button } from "app/components/ui/button";

const faqData = [
  {
    id: 1,
    question:
      "Why should I switch to VLE Mobile as a rideshare or delivery driver?",
    answer:
      "Get triple network coverage, up to $5M identity protection included free, unlimited data rollover, and no contracts. Save money while staying connected.",
  },
  {
    id: 2,
    question: "How does triple network technology help me while driving?",
    answer:
      "Your phone automatically switches between AT&T, T-Mobile, and Verizon for the strongest signal, ensuring uninterrupted navigation and customer communication everywhere you drive. If you require it, you can also switch networks manually from the settings.",
  },
  {
    id: 3,
    question:
      "What identity protection do I get, and why does it matter for drivers?",
    answer:
      "Aura protection includes dark web monitoring, SSN monitoring, account breach alerts, password manager, VPN, spam blocking, and up to $5M identity theft insurance.",
  },
  {
    id: 4,
    question:
      "Can I use my phone internationally if I drive passengers to the airport or cross borders?",
    answer:
      "Aura monitors public records and alerts you if your vehicle title is transferred, removed, or altered. Prevents title theft fraud targeting high-mileage driver vehicles.",
  },
  {
    id: 5,
    question: "What happens to my unused data each month?",
    answer:
      "Unused data rolls over automatically with unlimited carryover on 3GB, 5GB, and 15GB plans. Never waste data you paid for during slower months.",
  },
  {
    id: 6,
    question: "How much money can I save compared to my current carrier?",
    answer:
      "Save $30 to $50 monthly. Plans start at $25/month including identity protection worth $30-$50 alone. That's $360 to $600 saved yearly.",
  },
  {
    id: 7,
    question: "Do I need a new phone to use VLE Mobile?",
    answer:
      "Most modern smartphones work. Dual SIM plans need 2020 or newer phones. Older 4G devices work with our single network plans. Check compatibility online.",
  },
  {
    id: 8,
    question:
      "What if I have family members who aren't drivers? Can they benefit too?",
    answer:
      "Family plans cover up to 5 lines with savings. Each person gets complete identity protection, parental controls, child monitoring, and shared family alerts.",
  },
  {
    id: 9,
    question: "How quickly can I switch to VLE Mobile without losing service?",
    answer:
      "Activate in minutes and keep your number. Most transfers complete within hours with no downtime. Continue driving while your service transitions seamlessly.",
  },
  {
    id: 10,
    question: "What support do I get if I have issues while on the road?",
    answer:
      "Access 24/7/365 customer support via phone, chat, or email. 100% US based team answers 80% of calls within 30 seconds. Help whenever needed.",
  },
];

export const Faq = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const handleFaqToggle = (faqId: number) => {
    setOpenFaq(openFaq === faqId ? null : faqId);
  };

  return (
    <section className="px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 pt-9 sm:pt-14 md:pt-[4.5rem] lg:pt-[5.63rem] pb-14 sm:pb-[4.5rem] md:pb-[5.5rem] lg:pb-[7.5rem]">
      <div className="w-full max-w-[65.75rem] mx-auto">
        <div className="mb-6 text-center sm:mb-9 md:mb-12 lg:mb-14 2xl:mb-[3.75rem]">
          <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[5.25rem]">
            Frequently Asked Questions
          </h2>
          <p className="text-[#1D1D1B] text-[0.925rem] sm:text-base lg:text-lg font-normal leading-5 sm:leading-6 lg:leading-[1.75rem]">
            Find answers to common questions about our service
          </p>
        </div>
        <ul className="mx-auto space-y-4 w-full sm:space-y-5 lg:space-y-6">
          {faqData.map((faq, index) => (
            <li
              key={index}
              className={`pt-0 overflow-hidden transition-all duration-100 ease-in-out ${
                openFaq === faq.id
                  ? "pb-3 sm:pb-3.5 md:pb-4 lg:pb-[1.125rem]"
                  : "pb-5 sm:pb-7 lg:pb-[1.94rem]"
              } ${
                index === faqData.length - 1
                  ? "border-b-0"
                  : "border-b border-[#E4E7EC]"
              }`}
            >
              <Button
                type="button"
                variant="ghost"
                className="gap-4 justify-between w-full text-left rounded-none transition-colors duration-100 hover:bg-transparent sm:gap-6"
                onClick={() => handleFaqToggle(faq.id)}
                aria-expanded={openFaq === faq.id}
                aria-controls={`faq-content-${faq.id}`}
              >
                <h4 className="font-mobile text-[#101828] text-[0.925rem] sm:text-base lg:text-lg font-medium leading-5 sm:leading-6 lg:leading-7 flex-1 min-w-0">
                  <span className="whitespace-normal break-words line-clamp-2">
                    {faq.question}
                  </span>
                </h4>
                <div className="shrink-0">
                  <img
                    src={
                      openFaq === faq.id
                        ? "/assets/minus-circle.svg"
                        : "/assets/plus-circle.svg"
                    }
                    alt={openFaq === faq.id ? "Collapse" : "Expand"}
                    className="size-5 sm:size-[1.375rem] lg:size-6 transition-transform duration-100 ease-in-out"
                  />
                </div>
              </Button>
              <div
                id={`faq-content-${faq.id}`}
                className={`overflow-y-auto transition-all duration-100 ease-in-out ${
                  openFaq === faq.id
                    ? "max-h-96 opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-[#667085] text-sm sm:text-[0.925rem] lg:text-base font-normal leading-5 sm:leading-[1.375rem] lg:leading-6 pt-1 sm:pt-1.5 lg:pt-2">
                  {faq.answer}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
